import React from 'react'
import { FlexGrid } from 'ui'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import { TagCard } from 'ui/cards/TagCard'
import { Pipeline } from '@morningtrain/react-pipelines'
import { TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { NavigateOnPipe } from '@morningtrain/react-navigation'

export default function EmployeeFileTags ({ children }) {
  return (
    <Collection resourceName='files.tags'>
      {children}

      <FlexGrid className='mt-4 mb-12' responsive={{ xl: 3, md: 2 }}>
        <ForEachModel>
          <Pipeline>
            <TriggerPipelineOnClick>
              <TagCard />
            </TriggerPipelineOnClick>
            <NavigateOnPipe route='app.files.employee_files.view_tag' routeParameters={{ file_tag: 'model:id' }} />
          </Pipeline>
        </ForEachModel>
      </FlexGrid>
    </Collection>
  )
}
